import { render, staticRenderFns } from "./ModalDeletarUsuario.vue?vue&type=template&id=1ad4c3c1"
import script from "./ModalDeletarUsuario.vue?vue&type=script&lang=js"
export * from "./ModalDeletarUsuario.vue?vue&type=script&lang=js"
import style0 from "./ModalDeletarUsuario.vue?vue&type=style&index=0&id=1ad4c3c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports